import { CollapsibleSection } from "components/collapsibleSection";
import { IPickupAttractionParticipantDetail } from "interfaces";
import moment from "moment";

export const PickupInformationSection = ({participantDetailData} : {participantDetailData: IPickupAttractionParticipantDetail | null}) => {
  return (
    <CollapsibleSection 
      label="Pickup Information"
      defaultOpen={true}
    >
      <div className="grid gap-x-4 gap-y-6 px-4 py-4 text-sm sm:px-6 grid-cols-12 lg:gap-x-6" style={{wordBreak: "break-word"}}>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6">
          <div className="col-span-2">
            <p className="font-medium">
              POS name
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.pos}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6">
          <div className="col-span-2">
            <p className="font-medium">
              Pickup at
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.pick_time ? moment(participantDetailData.participant.pick_time).format("DD/MM/YYYY HH:mm:ss") : ""}
            </p>
          </div>
        </div>
      </div>
    </CollapsibleSection> 
  )
}